<template>
  <AdminTopBar :title="color.title || 'Nieuwe kleur'">
    <template #actions>
      <Button icon="Trash" responsive type="button" @click="remove(id)">
        Verwijder
      </Button>
      <Button icon="Save" responsive type="submit" color="cta" @click.prevent="submit">
        Opslaan
      </Button>
    </template>
  </AdminTopBar>

  <AdminForm :class="$style['form']" @submit="submit">
    <FormInput v-model="color.title" name="title" label="Titel" />
    <FormInput v-model="color.slug" name="slug" label="Slug" />
    <FormInput v-model="color.hex" name="hex" label="Selecteer kleur" type="color" />
  </AdminForm>
</template>
<script setup lang="ts">
import slugify from '~/helpers/slugify'
const { $api } = useNuxtApp()

const emit = defineEmits(['close'])
const props = defineProps<{
  id: number | string | null
}>()

const color = ref({ title: null, slug: null, hex: null })

if (props.id) {
  const { data } = await useApi(`colors/${props.id}`)
  if (data) {
    color.value = data.value
  }
}

const submit = async () => {
  await $api(props.id ? `colors/${props.id}` : 'colors', {
    method: props.id ? 'PUT' : 'POST',
    body: color.value
  })
  emit('close')
}

const remove = async (id: string) => {
  if (await !confirm('Kleur verwijderen?')) { return }
  await $api(`colors/${id}`, { method: 'DELETE' })
  emit('close')
}

watch(() => color.value.title, () => {
  color.value.slug = slugify(color.value.title)
})

</script>
<style module>
.form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}
</style>
